const BaseWidget = () => {
	return (
		<div className="base-widget">
		</div>
	);
};

export default BaseWidget;
